export function extractDomain(url: string): string {
  try {
    const { hostname } = new URL(url);
    return hostname.replace("www.", "");
  } catch (_error) {
    return url;
  }
}
